import { z } from 'zod';
import { ReservationStatusSchema } from './dashboard.js';

export const BundleOptionTypeEnum = z.enum(['combined', 'oversize']);
export type BundleOptionType = z.infer<typeof BundleOptionTypeEnum>;

export const BundleSchema = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string().nullable(),
});
export type Bundle = z.infer<typeof BundleSchema>;

export const BundleMemberSchema = z.object({
  mediaUnitId: z.number(),
  supplierNumber: z.string().nullable(),
  status: ReservationStatusSchema,
  address: z.string().nullable(),
});
export type BundleMember = z.infer<typeof BundleMemberSchema>;

export const BundleOptionCostSchema = z.object({
  id: z.number(),
  extraCost: z.number().nullable(),
  description: z.string().nullable(),
});
export type BundleOptionCost = z.infer<typeof BundleOptionCostSchema>;

export const BundleOptionSchema = z.object({
  id: z.number(),
  optionType: BundleOptionTypeEnum,
  minMembersRequired: z.number().nullable(),
  description: z.string().nullable(),
});
export type BundleOption = z.infer<typeof BundleOptionSchema>;

export const BundleDetailSchema = BundleSchema.extend({
  members: z.array(BundleMemberSchema),
  options: z.array(BundleOptionSchema.extend({ costs: z.array(BundleOptionCostSchema) })),
});
export type BundleDetail = z.infer<typeof BundleDetailSchema>;
